export default function ViewSelector({ currentView, onViewChange, canWrite, canReview }) {
  const views = [
    { id: 'classic',        label: 'Classic Map' },
    { id: 'address-search', label: 'Address Search' },
    { id: 'new-deal',       label: 'New Deal' },
    ...(canReview ? [{ id: 'review-queue', label: 'Review Queue' }] : []),
  ]

  return (
    <div style={{
      display: 'flex',
      gap: 8,
      padding: '12px 16px',
      background: '#061020',
      borderBottom: '1px solid rgba(212,175,55,0.2)',
      flexShrink: 0,
    }}>
      {views.map(view => (
        <button
          key={view.id}
          onClick={() => onViewChange(view.id)}
          style={{
            padding: '6px 12px',
            background: currentView === view.id
              ? '#D4AF37'
              : 'rgba(255,255,255,0.08)',
            color: currentView === view.id ? '#0A192F' : '#FFFFFF',
            border: '1px solid ' + (currentView === view.id
              ? '#D4AF37'
              : 'rgba(212,175,55,0.2)'),
            borderRadius: 4,
            fontWeight: currentView === view.id ? 600 : 500,
            fontSize: 12,
            cursor: 'pointer',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
          }}
        >
          {view.label}
        </button>
      ))}
    </div>
  )
}
